import { useContext } from "react";

import { UserContext } from "../../../shared/auth/user-context";

/**
 * Single source of truth for CCF module access: any solution the user is allowed to calculate.
 * Deliberately not `useGetEnabledCfcSolutions().isCcfEnabled`, which reads the service permissions
 * only — `allowedSolutions` also covers internal staff and trial customers (see
 * `getAllowedSolutions` in the user provider).
 */
export function useHasCcfAccess(): boolean {
  const { user } = useContext(UserContext);

  return user !== null && user.allowedSolutions.length > 0;
}
